/* ==========================================================================
   RYMBU "Gratis erbij"-deal — automatische cadeau-sync
   --------------------------------------------------------------------------
   Leest de deal-config uit <script data-ry-gratis-config> tags (gerenderd
   door ry-gratis-deal.liquid op de productpagina en ry-gratis-deal-data.liquid
   in cart-drawer/cart-pagina) en houdt de winkelwagen in sync:

     1. Trigger-product X in cart  -> cadeaus Y/Z automatisch toevoegen
        (met line item property _ry_gratis = product-id van X).
     2. Trigger-product X uit cart -> door ons toegevoegde cadeaus verwijderen.
     3. Klant verwijdert een cadeau bewust -> respecteren (opt-out, deze sessie
        niet opnieuw toevoegen).
     4. VANGNET: is een toegevoegd cadeau NIET 100% gratis (korting verlopen,
        verkeerd geconfigureerd, aantal-voorwaarde niet gehaald), dan wordt het
        meteen weer verwijderd. Zo betaalt een klant nooit ongewild voor een
        "gratis" product.

   Het gratis maken zelf gebeurt door een automatische korting (Koop X krijg Y)
   in Shopify admin — zie RYMBU-GRATIS-DEAL.md voor het stappenplan.
   ========================================================================== */
(function () {
  'use strict';

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;
  var PROP = '_ry_gratis';
  var SS_KEY = 'ryGratisDeal';
  var DEBOUNCE_MS = 350;
  var SETTLE_MS = 1500;   // korte hercontrole na een mutatie (transiente fouten)
  var MAX_SETTLE = 4;     // max automatische hercontroles per activiteits-burst

  var syncing = false;
  var resyncQueued = false;
  var internalCall = false;
  var timer = null;
  var settleLeft = MAX_SETTLE;

  function getRoutes() {
    var r = window.routes || {};
    return {
      cart: r.cart_url || '/cart',
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change'
    };
  }

  /* ---------- sessie-state (wat voegden wij toe / wat wees de klant af) --- */

  function loadState() {
    var s = {};
    try { s = JSON.parse(sessionStorage.getItem(SS_KEY)) || {}; } catch (e) { s = {}; }
    if (typeof s.added !== 'object' || !s.added) s.added = {};
    if (typeof s.optout !== 'object' || !s.optout) s.optout = {};
    if (typeof s.choice !== 'object' || !s.choice) s.choice = {};
    return s;
  }

  function saveState(s) {
    try { sessionStorage.setItem(SS_KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
  }

  /* ---------- deal-config uit de DOM --------------------------------------- */

  function readDeals() {
    var deals = {}; // trigger product-id (string) -> { choice: bool, gifts: [{id,qty}] }
    var els = document.querySelectorAll('script[data-ry-gratis-config]');
    for (var i = 0; i < els.length; i++) {
      var arr;
      try { arr = JSON.parse(els[i].textContent); } catch (e) { continue; }
      if (!Array.isArray(arr)) continue;
      arr.forEach(function (d) {
        if (!d || !d.trigger || !Array.isArray(d.gifts) || !d.gifts.length) return;
        var key = String(d.trigger);
        if (!deals[key]) deals[key] = { choice: false, gifts: [] };
        if (d.choice) deals[key].choice = true;   // keuze-modus: klant kiest ÉÉN cadeau
        d.gifts.forEach(function (g) {
          // Formaat: {id, qty}. Een kaal getal (oudere gecachte pagina) = 1 stuk.
          var id = Number(g && typeof g === 'object' ? g.id : g);
          var qty = Math.round(Number(g && typeof g === 'object' ? g.qty : 1)) || 1;
          if (!id || qty < 1) return;
          var existing = null;
          deals[key].gifts.forEach(function (x) { if (x.id === id) existing = x; });
          if (existing) {
            if (qty > existing.qty) existing.qty = qty;
          } else {
            deals[key].gifts.push({ id: id, qty: qty });
          }
        });
      });
    }
    return deals;
  }

  /* ---------- cart API ------------------------------------------------------ */

  function internalFetch(url, cfg) {
    internalCall = true;
    try {
      return window.fetch(url, cfg);
    } finally {
      internalCall = false;
    }
  }

  function fetchCart() {
    return window.fetch(getRoutes().cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Alle cadeaus in ÉÉN atomair request. Zo is er geen tussenmoment waarop een
  // deel van de cadeaus in de cart zit (belangrijk voor kortingen die pas
  // vrijgeven als ALLE cadeaus aanwezig zijn, bv. "2 stuks uit deze lijst") en
  // geen race tussen losse adds.
  function addItems(items) {
    return internalFetch(getRoutes().add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  // Eén cadeau per request — fallback als de batch faalt (bv. één cadeau net
  // niet leverbaar): zo blokkeert dat de andere cadeaus niet.
  function addItem(item) {
    return internalFetch(getRoutes().add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(item)
    }).then(function (r) {
      if (r.ok) return true;
      return r.json().then(function (j) {
        console.warn('[ry-gratis-deal] cadeau toevoegen mislukt (variant ' + item.id + '):',
          j && (j.description || j.message));
        return false;
      }, function () { return false; });
    }).catch(function () { return false; });
  }

  function removeLine(key) {
    return internalFetch(getRoutes().change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  /* ---------- secties her-renderen (drawer, cart-pagina, icoon) ------------ */

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = selector ? doc.querySelector(selector) : doc.body;
    return el ? el.innerHTML : null;
  }

  function renderSections() {
    var jobs = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && document.getElementById('CartDrawer')) {
      jobs.push({
        id: 'cart-drawer',
        apply: function (html) {
          var content = sectionInnerHTML(html, '#CartDrawer');
          if (content === null) return;
          document.getElementById('CartDrawer').innerHTML = content;
          // overlay zit binnen #CartDrawer: click-to-close opnieuw koppelen
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      });
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      jobs.push({
        id: 'cart-icon-bubble',
        apply: function (html) {
          var content = sectionInnerHTML(html, '.shopify-section');
          if (content === null) return;
          (bubble.querySelector('.shopify-section') || bubble).innerHTML = content;
        }
      });
    }
    var mci = document.getElementById('main-cart-items');
    if (mci && mci.dataset.id) {
      jobs.push({
        id: mci.dataset.id,
        apply: function (html) {
          var content = sectionInnerHTML(html, '.js-contents');
          var target = mci.querySelector('.js-contents');
          if (content !== null && target) target.innerHTML = content;
        }
      });
    }
    var mcf = document.getElementById('main-cart-footer');
    if (mcf && mcf.dataset.id) {
      jobs.push({
        id: mcf.dataset.id,
        apply: function (html) {
          var content = sectionInnerHTML(html, '.js-contents');
          var target = mcf.querySelector('.js-contents');
          if (content !== null && target) target.innerHTML = content;
        }
      });
    }
    if (!jobs.length) return Promise.resolve();

    var ids = [];
    jobs.forEach(function (j) { if (ids.indexOf(j.id) === -1) ids.push(j.id); });

    return fetchCart().then(function (cart) {
      var url = getRoutes().cart + '?sections=' + encodeURIComponent(ids.join(','));
      return window.fetch(url).then(function (r) { return r.json(); }).then(function (sections) {
        jobs.forEach(function (j) {
          if (sections && sections[j.id]) {
            try { j.apply(sections[j.id]); } catch (e) { console.warn('[ry-gratis-deal] sectie-render faalde:', e); }
          }
        });
        var isEmpty = cart.item_count === 0;
        if (drawer) drawer.classList.toggle('is-empty', isEmpty);
        var cartItemsEl = document.querySelector('cart-items');
        if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', isEmpty);
        if (mcf) mcf.classList.toggle('is-empty', isEmpty);
        updateChoiceUI();  // net her-gerenderde keuze-radio's op de juiste stand zetten
      });
    });
  }

  /* ---------- keuze-deals: radio's <-> opgeslagen keuze ------------------- */

  // Zet alle keuze-radio's op de gekozen optie (of laat de server-default staan).
  function updateChoiceUI() {
    var st = loadState();
    var radios = document.querySelectorAll('input[data-ry-choice-trigger]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var sel = st.choice[r.getAttribute('data-ry-choice-trigger')];
      if (sel != null) r.checked = (Number(r.getAttribute('data-ry-choice-variant')) === Number(sel));
    }
  }

  // Klant kiest een ander cadeau -> keuze bewaren, eventuele opt-out wissen,
  // en de winkelwagen laten omwisselen.
  function onChoiceChange(e) {
    var r = e.target;
    if (!r || !r.getAttribute || !r.getAttribute('data-ry-choice-trigger')) return;
    var trigger = r.getAttribute('data-ry-choice-trigger');
    var variant = Number(r.getAttribute('data-ry-choice-variant'));
    if (!variant) return;
    var st = loadState();
    st.choice[trigger] = variant;
    // Actief kiezen heft elke eerdere weigering/niet-gratis-opt-out voor dit
    // toestel op — zowel de oude per-toestel-sleutel als alle per-variant-sleutels.
    delete st.optout[trigger];
    var prefix = trigger + ':';
    Object.keys(st.optout).forEach(function (k) {
      if (k.indexOf(prefix) === 0) delete st.optout[k];
    });
    saveState(st);
    updateChoiceUI();
    schedule(true);
  }
  document.addEventListener('change', onChoiceChange);

  /* ---------- vangnet: toegevoegde cadeaus moeten écht gratis zijn --------- */

  // Verwijdert ONZE cadeau-regels die niet (volledig) gratis werden, en zet daar
  // een opt-out op. Belangrijk detail: Shopify wijst kortingen per VARIANT over
  // de hele cart toe (goedkoopste eerst), niet per line-item-property, en SPLITST
  // een cadeau-regel die maar deels gedekt is in een gratis deelregel
  // (final == 0) en een volledig-betaalde deelregel (final == original). We
  // verwijderen dus simpelweg elke cadeau-regel met final_line_price > 0 — dat is
  // precies de niet-gedekte hoeveelheid; de gratis eenheden blijven staan.
  // Werkt in één klap voor "korting dekt maar een deel" én "geen korting".
  //
  // Begrensde lus: na een verwijdering kan de korting heralloceren, dus opnieuw
  // ophalen en resterende betaalde cadeau-regels wegwerken tot er geen meer zijn.
  function verifyFree(state, _pass) {
    _pass = _pass || 0;
    return fetchCart().then(function (cart) {
      var bad = cart.items.filter(function (it) {
        var t = it.properties && it.properties[PROP];
        return t && it.final_line_price > 0;
      });
      if (!bad.length) return _pass > 0;

      var warned = false;
      var chain = Promise.resolve();
      bad.forEach(function (it) {
        var key = String(it.properties[PROP]) + ':' + it.variant_id;
        if (!warned) {
          warned = true;
          console.warn(
            '[ry-gratis-deal] "' + it.product_title + '" werd NIET (volledig) gratis gemaakt door ' +
            'een korting — de betaalde eenheden zijn verwijderd zodat de klant er niet voor betaalt. ' +
            'Meest voorkomende oorzaak: geen (dekkende) automatische korting voor dit cadeau, of de ' +
            'korting geeft te weinig stuks gratis. Controleer de korting (audit.py).'
          );
        }
        delete state.added[key];
        state.optout[key] = 1;
        chain = chain.then(function () { return removeLine(it.key); });
      });
      saveState(state);
      // Nog een pass om herallocatie op te vangen (begrensd tegen loops).
      return chain.then(function () {
        if (_pass < 3) return verifyFree(state, _pass + 1);
        return true;
      });
    });
  }

  /* ---------- de eigenlijke sync ------------------------------------------- */

  function sync() {
    if (syncing) { resyncQueued = true; return; }
    syncing = true;

    var state = loadState();
    var deals = readDeals();

    fetchCart().then(function (cart) {
      var inCart = {};    // product-id (string) -> true
      var ourQty = {};    // "trigger:variant-id" -> aantal op ONZE cadeau-regels
      var ourLines = {};  // trigger -> [{ variant, key }]  (onze cadeau-regels)
      var hasPaidGift = false;  // staat er al een betaalde cadeau-regel in de cart?
      cart.items.forEach(function (it) {
        inCart[String(it.product_id)] = true;
        var t = it.properties && it.properties[PROP];
        if (t) {
          var trig = String(t);
          var k = trig + ':' + it.variant_id;
          ourQty[k] = (ourQty[k] || 0) + it.quantity;
          (ourLines[trig] = ourLines[trig] || []).push({ variant: it.variant_id, key: it.key });
          if (it.final_line_price > 0) hasPaidGift = true;
        }
      });

      // 1) Opruimen: door ons gemarkeerde cadeaus waarvan de trigger weg is.
      //    (Werkt zonder config — de property draagt het trigger-product-id.)
      var removeKeys = [];
      cart.items.forEach(function (it) {
        var t = it.properties && it.properties[PROP];
        if (t && !inCart[String(t)]) removeKeys.push(it.key);
      });

      // 1b) added/optout opruimen voor ELK toestel dat niet (meer) in de cart
      //     zit — bewust op basis van de CART, niet van de config. Zodra een
      //     toestel uit de winkelwagen gaat, verdwijnt namelijk ook zijn
      //     config-blok; hing het opruimen daaraan, dan bleef een opt-out
      //     eeuwig staan en kreeg de klant bij opnieuw toevoegen géén cadeaus.
      //     LET OP: state.choice NIET opruimen — dat is een klant-voorkeur die
      //     al gezet kan zijn op de PRODUCTPAGINA vóór het toestel in de cart
      //     zit (keuze-radio's). Wisten we die hier, dan verviel de keuze naar
      //     de default zodra het toestel werd toegevoegd (plancha-keuze werd dan
      //     alsnog houtskool). Choice blijft dus bewaard; onschadelijk.
      [state.added, state.optout].forEach(function (bucket) {
        Object.keys(bucket).forEach(function (k) {
          if (!inCart[k.split(':')[0]]) delete bucket[k];
        });
      });

      // 2) Toevoegen: cadeaus van triggers die in de cart zitten.
      var toAdd = [];
      Object.keys(deals).forEach(function (trigger) {
        if (!inCart[trigger]) return;   // deal niet van toepassing
        var deal = deals[trigger];
        var props = {};
        props[PROP] = trigger;

        if (deal.choice) {
          // KEUZE-DEAL: precies ÉÉN cadeau (het gekozene) hoort in de cart.
          var giftById = {};
          deal.gifts.forEach(function (g) { giftById[g.id] = g; });
          var selected = Number(state.choice[trigger]);
          if (!selected || !giftById[selected]) selected = deal.gifts[0].id; // default: 1e optie

          // Onze cadeau-regels voor dit toestel die NIET het gekozene zijn:
          // weghalen (dit is een bewuste wissel, geen klant-verwijdering).
          (ourLines[trigger] || []).forEach(function (line) {
            if (giftById[line.variant] && line.variant !== selected) {
              removeKeys.push(line.key);
              delete state.added[trigger + ':' + line.variant];
            }
          });

          var selKey = trigger + ':' + selected;
          if (ourQty[selKey]) return;             // gekozen cadeau zit er al
          if (state.optout[selKey]) return;       // dit gekozen cadeau werd afgewezen/niet-gratis
          if (state.added[selKey]) {
            // Wij voegden het gekozene toe, maar het is weg -> klant verwijderde
            // het bewust -> dit cadeau deze sessie niet meer aanvullen.
            delete state.added[selKey];
            state.optout[selKey] = 1;
            return;
          }
          toAdd.push({ id: selected, quantity: giftById[selected].qty, properties: props });
          return;
        }

        // STANDAARD-DEAL: alle cadeaus krijgen.
        deal.gifts.forEach(function (gift) {
          var key = trigger + ':' + gift.id;
          // Onze eigen cadeau-regel staat er al: met rust laten (ook als de
          // klant het aantal zelf aanpaste). Een exemplaar dat de klant ZELF
          // kocht telt niet mee — die betaalt hij, het cadeau komt er bovenop.
          if (ourQty[key]) return;
          if (state.optout[key]) return;          // klant wees dit cadeau af
          if (state.added[key]) {
            // Wij voegden het toe, maar het is weg -> klant verwijderde het bewust.
            delete state.added[key];
            state.optout[key] = 1;
            return;
          }
          toAdd.push({ id: gift.id, quantity: gift.qty, properties: props });
        });
      });
      saveState(state);

      var mutated = false;
      var chain = Promise.resolve();

      removeKeys.forEach(function (key) {
        chain = chain.then(function () {
          mutated = true;
          return removeLine(key);
        });
      });

      var addedAny = false;
      var addFailed = false;
      if (toAdd.length) {
        mutated = true;
        chain = chain.then(function () {
          return addItems(toAdd).then(function (ok) {
            if (ok) return toAdd;  // batch geslaagd: alle cadeaus toegevoegd
            // Batch mislukte: val terug op stuk-voor-stuk zodat de rest die
            // wél kan, alsnog wordt toegevoegd.
            var okItems = [];
            var seq = Promise.resolve();
            toAdd.forEach(function (item) {
              seq = seq.then(function () {
                return addItem(item).then(function (ok2) {
                  if (ok2) okItems.push(item); else addFailed = true;
                });
              });
            });
            return seq.then(function () { return okItems; });
          }).then(function (okItems) {
            okItems.forEach(function (item) {
              // Waarde = het aantal dat WIJ toevoegden.
              state.added[item.properties[PROP] + ':' + item.id] = item.quantity;
              addedAny = true;
            });
            saveState(state);
          });
        });
      }

      // Vangnet: draait na een toevoeging ÉN wanneer er al een betaalde
      // cadeau-regel in de cart stond (bv. een gesplitste regel uit een eerdere
      // sessie/paginaweergave), zodat zo'n regel ook zonder nieuwe toevoeging
      // wordt opgeschoond.
      var verifiedRemoved = false;
      chain = chain.then(function () {
        if (addedAny || hasPaidGift) {
          return verifyFree(state).then(function (removed) { verifiedRemoved = !!removed; });
        }
      });

      return chain.then(function () {
        if (mutated || verifiedRemoved) return renderSections();
      }).then(function () {
        // Eén begrensde hercontrole na elke toevoeging/fout/opschoning: die
        // herleest de ÉCHTE cart en convergeert naar de gewenste cadeaus.
        // Idempotent — al aanwezige/gratis cadeaus worden overgeslagen, dus zodra
        // alles klopt doet een volgende sync niets meer en stopt de reeks vanzelf.
        if ((addedAny || addFailed || verifiedRemoved) && settleLeft > 0) {
          settleLeft--;
          clearTimeout(timer);
          timer = setTimeout(sync, SETTLE_MS);
        }
      });
    }).catch(function (e) {
      console.warn('[ry-gratis-deal] sync mislukt:', e);
    }).then(function () {
      syncing = false;
      if (resyncQueued) {
        // resyncQueued wordt alleen gezet door schedule() (altijd een
        // gebruikersactie/paginaweergave); de settle-hercontrole gaat rechtstreeks.
        resyncQueued = false;
        schedule(true);
      }
    });
  }

  // isUserEvent = echte cart-mutatie of paginaweergave (geen settle-hercontrole):
  // dan mag de automatische-hercontrole-teller weer vol, want er is nieuwe
  // activiteit die opnieuw tot stragglers kan leiden.
  function schedule(isUserEvent) {
    if (isUserEvent) settleLeft = MAX_SETTLE;
    if (syncing) { resyncQueued = true; return; }
    clearTimeout(timer);
    timer = setTimeout(sync, DEBOUNCE_MS);
  }

  /* ---------- cart-mutaties van het theme (en apps) opvangen --------------- */

  // fetch (theme: product-form.js, cart.js, quick-add, ...)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = '';
    try {
      url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    } catch (e) { /* ignore */ }
    var p = origFetch.apply(this, arguments);
    if (!internalCall && CART_MUTATION_RE.test(url)) {
      p.then(function () { schedule(true); }, function () { /* ignore */ });
    }
    return p;
  };

  // XMLHttpRequest (bv. jQuery-gebaseerde apps/upsells)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (typeof url === 'string' && CART_MUTATION_RE.test(url)) {
        this.addEventListener('load', function () { schedule(true); });
      }
    } catch (e) { /* ignore */ }
    return origOpen.apply(this, arguments);
  };

  // Bij elke paginaweergave één keer controleren (zelfherstellend: vangt ook
  // wijzigingen uit andere tabs of gemiste events op) + keuze-radio's zetten.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { updateChoiceUI(); schedule(true); });
  } else {
    updateChoiceUI();
    schedule(true);
  }

  // Terugkeer uit checkout/andere pagina via de back-knop (bfcache): dan vuurt
  // DOMContentLoaded niet, maar pageshow wel.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) schedule(true);
  });

  // Handmatig te triggeren voor debugging: window.ryGratisSync()
  window.ryGratisSync = function () { schedule(true); };
})();
